import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import AppContext from '../AppContext';
import { AddOrDeleteOrganizationPayload } from './generated/types';

export const useDeleteOrganization = (id: string) => {
    const context = useContext(AppContext);

    return useMutation({
        mutationFn: async () => {

            const mutation = `mutation MyMutation {
            deleteOrganization(id: "${id}") {
              id
            }
          }`;

            await (context.api.graphql({ query: mutation }) as Promise<{
                data: {
                    deleteOrganization: AddOrDeleteOrganizationPayload;
                };
            }>);

            return true;
        },
    });
};
